import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Nav, NavItem, NavLink, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import classnames from 'classnames';
import { Switch, Route, Link } from 'react-router-dom'
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { loadRestaurant, clearRestaurant } from '../../actions/index';
import { isUserAllowedToAccessRestaurant, isUserAllowedToAccessRestaurantBrand } from '../../utils/CommonUtils';

import RestaurantSettingsContainer from './settings/RestaurantSettingsContainer';
import MenuConfigScreen from "./posmenu/MenuConfigScreen";
import OrdersHistory from './orders/OrdersHistory';
import { loadNotifications } from "../../actions";
import PromotionsScreen from './promotions/PromotionsScreen';
import ReportsScreen from "./reports/ReportsScreen";
import LoyaltyScreen from "./loyalty/LoyaltyScreen";
import UpsellScreen from "./upsell/UpsellScreen";
import CustomerInsightScreen from './customerInsightScreen/CustomerInsightScreen';
import RestaurantInsightScreen from './restaurantInsight/RestaurantInsightScreen';
import CustomersContainer from './customers/CustomersContainer';
import AutomationListScreen from './marketingAutomations/AutomationListScreen';
import MarketingAutomationScreen from './marketingAutomations/MarketingAutomationScreen';
class RestaurantMainContainer extends Component {

    constructor(props) {
        super(props);

        this.state = { collapse: false };

        this.state = {
            activeTab: 'settings',
            collapse: true
        };
    }

    componentWillMount() {
        const { id } = this.props.match.params;

        let restaurantId = Number(id);

        if (restaurantId !== -1) {
            this.props.loadRestaurant(restaurantId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            const { id } = this.props.match.params;

            let restaurantId = Number(id);

            if (restaurantId !== -1) {
                this.props.loadRestaurant(restaurantId);
            }
        }
    }

    componentWillUnmount() {
        this.props.clearRestaurant();
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    renderLinkRestaurantLink() {
        const { restaurantBreadCrumb } = styles;

        return (
            <BreadcrumbItem style={restaurantBreadCrumb}>
                <Link to={'/restaurants'}>{i18n.t('screens:restaurantsMainContainer.restaurants')}</Link>
            </BreadcrumbItem>
        );
    }

    renderLinkBrandLink() {
        const { restaurant, currentlyLoggedInUser } = this.props;
        const userAllowedToAccessBrand = isUserAllowedToAccessRestaurantBrand(restaurant, currentlyLoggedInUser);

        if (this.props.restaurant.chain.id !== -1) {
            if (userAllowedToAccessBrand) {
                return (
                    <BreadcrumbItem>
                        <Link
                            to={`/brand/${this.props.restaurant.chain.id}`}>{this.props.restaurant.chain.name}</Link>
                    </BreadcrumbItem>
                );
            } else {
                return <BreadcrumbItem>{this.props.restaurant.chain.name}</BreadcrumbItem>;
            }
        } else if (this.props.brand !== undefined) {
            return (
                <BreadcrumbItem>
                    <Link
                        to={`/brand/${this.props.brand.id}`}>{this.props.brand.name}</Link>
                </BreadcrumbItem>
            );
        }
    }

    renderRestrictedBrandAccess() {
        return <BreadcrumbItem>{this.props.brand.name}</BreadcrumbItem>;
    }

    renderLinkLocationLink() {

        if (this.props.restaurant.location !== undefined) {
            return (
                <BreadcrumbItem>
                    {this.props.restaurant.location}
                </BreadcrumbItem>
            );
        } else {
            return (
                <BreadcrumbItem>
                    {i18n.t('screens:restaurantsMainContainer.newRestaurant')}
                </BreadcrumbItem>
            );
        }
    }

    renderRemainingBreadcrumbItems = fields => {
        if (fields.length > 0 && fields[0] === 'customer-insight') {
            return (
                <React.Fragment>
                    <BreadcrumbItem>{i18n.t(`screens:restaurantsMainContainer.customer-insight`)}</BreadcrumbItem>
                    <BreadcrumbItem>{this.props.customerInsight.customerName}</BreadcrumbItem>
                </React.Fragment>
            )
        } else {
            return fields.map((pathElement, i) => {
                let key = { 'key': i };

                return (<BreadcrumbItem {...key} >{i18n.t(`screens:restaurantsMainContainer.${pathElement}`)}</BreadcrumbItem>)
            })
        }
    }

    renderBreadCrumb() {
        let fields = this.props.location.pathname.replace("/", "").replace(/\//g, " ").split(" ");
        fields = fields.splice(2, 2);
        const { zeroPadding } = styles;
        const { restaurant } = this.props;

        if (restaurant.id !== undefined && restaurant.id !== null) {

            return (
                <Col style={zeroPadding}>
                    <Breadcrumb style={{ paddingLeft: 10 }}>

                        {this.renderLinkRestaurantLink()}
                        {this.renderLinkBrandLink()}
                        {this.renderLinkLocationLink()}
                        {this.renderRemainingBreadcrumbItems(fields)}
                    </Breadcrumb>
                </Col>
            );
        } else {
            return (
                <Col />
            );
        }

    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    handlePromotionPartnerLogic = () => {

        const { type, chainLevelPromotionSettings, chainPromotionPartnerType } = this.props.promotionProviders;

        if (!type) {
            return false;
        }

        if (!chainLevelPromotionSettings && type.id === 2) {

            return true;
        } else if (chainLevelPromotionSettings && chainPromotionPartnerType.id === 2) {

            return true;
        }

        return false;
    }

    render() {

        const { containerStyle } = styles;
        const { id, section } = this.props.match.params;
        const { brand, restaurant, currentlyLoggedInUser } = this.props;

        const userAllowedToAccessRestaurant = isUserAllowedToAccessRestaurant(brand, restaurant, currentlyLoggedInUser);
        const isPromoSettingsHidden = this.handlePromotionPartnerLogic();

        if (userAllowedToAccessRestaurant) {
            return (
                <div>
                    {this.renderBreadCrumb()}
                    <Container fluid style={containerStyle}>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'settings' })} style={{ paddingLeft: '0.3rem' }}
                                    tag={Link} to={`/restaurant/${id}/settings/general`}>
                                    <MaterialIcon icon="settings" size={20} color='#000'
                                        className={classnames({ active: section === 'settings' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.settings')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'menuconfig' })}
                                    tag={Link} to={`/restaurant/${id}/menuconfig`}>
                                    <MaterialIcon icon="list_alt" size={20} color='#000'
                                        className={classnames({ active: section === 'settings' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.menuconfig')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === `orders` })}
                                    tag={Link} to={`/restaurant/${id}/orders`}>
                                    <MaterialIcon icon="shopping_cart" size={20} color='#000'
                                        className={classnames({ active: section === 'settings' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.orders')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'promotions' })}
                                    tag={Link} to={`/restaurant/${id}/promotions`}>
                                    <span style={{ marginRight: -18 }}>
                                        <MaterialIcon icon="styles" size={20} color='#000'
                                            className={classnames({ active: section === 'settings' })} />
                                    </span>
                                    {i18n.t('screens:restaurantsMainContainer.promotions')}
                                </NavLink>
                            </NavItem>
                            {
                                isPromoSettingsHidden ? null :
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: section === 'loyalty' })}
                                            tag={Link} to={`/restaurant/${id}/loyalty`}>
                                            <MaterialIcon icon="loyalty" size={20} color='#000'
                                                className={classnames({ active: section === 'loyalty' })}
                                            />
                                            {i18n.t('screens:restaurantsMainContainer.loyalty')}
                                        </NavLink>
                                    </NavItem>
                            }
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'upsell' })}
                                    tag={Link} to={`/restaurant/${id}/upsell`}>
                                    <MaterialIcon icon="call_made" size={20} color='#000'
                                        className={classnames({ active: section === 'settings' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.upsell')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'reports' })}
                                    tag={Link} to={`/restaurant/${id}/reports`}>
                                    <MaterialIcon icon="equalizer" size={20} color='#000'
                                        className={classnames({ active: section === 'settings' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.reports')}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'restaurant-insight' || section === 'customer-insight' })} style={{ paddingLeft: '0.3rem' }}
                                    tag={Link} to={`/restaurant/${id}/restaurant-insight`}>
                                    <MaterialIcon icon="insights" size={20} color='#000'
                                        className={classnames({ active: section === 'restaurant-insight' || section === 'customer-insight' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.insight')}
                                </NavLink>
                            </NavItem>
                            {
                                isPromoSettingsHidden ? null :
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: section === 'marketing-automations' || section === 'marketing-automation' })}
                                            tag={Link} to={`/restaurant/${id}/marketing-automations`}>
                                            <MaterialIcon icon="campaign" size={20} color='#000'
                                                className={classnames({ active: section === 'marketing-automations' || section === 'marketing-automation' })}
                                            />
                                            {i18n.t('screens:restaurantsMainContainer.marketing-automations')}
                                        </NavLink>
                                    </NavItem>
                            }
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: section === 'customers' })}
                                    tag={Link} to={`/restaurant/${id}/customers`}>
                                    <MaterialIcon icon="group" size={20} color='#000'
                                        className={classnames({ active: section === 'settings' })}
                                    />
                                    {i18n.t('screens:restaurantsMainContainer.customers')}
                                </NavLink>
                            </NavItem>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignSelf: 'center', flex: 1, marginRight: 80 }}>
                                <div hidden={!restaurant.posStatus} style={{ marginRight: 10, minWidth: 100 }}>POS: <span style={{ color: restaurant.posStatus === 'OFFLINE' || restaurant.posStatus === 'NOT_CONFIGURED' ? 'red' : 'green' }}>{i18n.t(`common:statuses.${restaurant.posStatus.toLowerCase()}`)}</span></div>
                                <div hidden={!restaurant.workingStatus} style={{ minWidth: 100 }}>{i18n.t('screens:orderHistoryScreen.status')}: <span style={{ color: restaurant.workingStatus === 'CLOSED' ? 'red' : 'green' }}>{i18n.t(`common:statuses.${restaurant.workingStatus.toLowerCase()}`)}</span></div>
                            </div>
                        </Nav>
                        <div>
                            <Switch>
                                <Route path='/restaurant/:id/settings' component={RestaurantSettingsContainer} />
                                <Route path='/restaurant/:id/menuconfig' component={MenuConfigScreen} />
                                <Route path='/restaurant/:id/orders' component={OrdersHistory} />
                                <Route path='/restaurant/:id/promotions' component={PromotionsScreen} />
                                <Route path='/restaurant/:id/loyalty' component={LoyaltyScreen} />
                                <Route path='/restaurant/:id/upsell' component={UpsellScreen} />
                                <Route path='/restaurant/:id/reports' component={ReportsScreen} />
                                <Route path='/restaurant/:id/customer-insight/:customerId' component={CustomerInsightScreen} />
                                <Route path='/restaurant/:id/restaurant-insight' component={RestaurantInsightScreen} />
                                <Route path='/restaurant/:id/customers' component={CustomersContainer} />
                                <Route path='/restaurant/:id/marketing-automations' component={AutomationListScreen} />
                                <Route path='/restaurant/:id/marketing-automation' component={MarketingAutomationScreen} />
                            </Switch>
                        </div>
                    </Container>
                </div>
            );
        } else {
            return (
                <Container>
                </Container>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        currentlyLoggedInUser: state.user,
        restaurant: state.restaurant,
        brand: state.brand,
        notifications: state.notifications,
        importInProgress: state.importInProgress,
        publishInProgress: state.publishInProgress,
        promotionProviders: state.promotionProviders,
        customerInsight: state.customerInsight
    };
};

export default connect(mapStateToProps, { loadRestaurant, clearRestaurant, loadNotifications })(RestaurantMainContainer);

let styles = {
    containerStyle: {
        width: '96%',
        marginTop: 10,
        paddingLeft: 0,
        paddingRight: 0
    },
    menuItem: {
        color: '#000',
        fontSize: 14,
        paddingTop: 10,
        paddingRight: 1,
        paddingBottom: 10,
        paddingLeft: 1,
        borderBottom: '1px solid #000'
    },
    subMenuItem: {
        color: '#000',
        fontSize: 14,
        marginLeft: 10
    },
    zeroPadding: {
        paddingLeft: 0,
        paddingRight: 0
    },
    authorizationErrorMessageContainer: {
        textAlign: 'center',
        marginTop: 100
    },
    restaurantBreadCrumb: {
        marginTop: '1.6px'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/RestaurantMainContainer.js